import React, { FunctionComponent, useEffect, useState } from "react";

import { DashboardEditorProps, IProductTemplateTableEditor } from "components/ComponentTypeTypes";
import { InputSwitchChangeEvent } from "primereact/inputswitch";
import { T } from "services/lang/LanguageService";
import { TabPanel, TabView } from "primereact/tabview";
import { InputNumberValueChangeEvent } from "primereact/inputnumber";
import { MultiSelectChangeEvent } from "primereact/multiselect";
import ProductTemplateGeneralConfig from "./ProductTemplateGeneralConfig";
import ProductTemplateTableConfig from "./ProductTemplateTableConfig";
import ProductTemplateOverriddenColumnValues from "./ProductTemplateOverriddenColumnValues";
import ProductTemplateLoadConfig from "./ProductTemplateLoadConfig";
import ProductTemplateFilterConfig from "./ProductTemplateFilterConfig";

export const defaultProductTemplateEditorConfig: IProductTemplateTableEditor = {
  id: undefined,
  safeName: "",
  transposed: false,
  showTitle: true,
  updateFrequency: undefined,
  hiddenColumns: [],
  onlyShownColumns: [],
  itemsPerPage: 15,
  overrideLoadingConfig: undefined,
  filter: undefined,
  defaultFilter: undefined,
  hideDates: false,
  showFilter: false,
  allowAddEntry: true,
  allowRowEdit: true,
  showTotals: false,
};

const ProductTemplateTableEditor = ({
  config,
  onConfigChange,
}: DashboardEditorProps<IProductTemplateTableEditor>) => {
  const [currentConfig, setCurrentConfig] = useState(() => {
    if (Object.keys(config).length > 0) {
      return config;
    }
    return defaultProductTemplateEditorConfig;
  });

  useEffect(() => {
    onConfigChange(currentConfig);
  }, [currentConfig]);

  const handleConfigChange = (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | InputNumberValueChangeEvent
      | InputSwitchChangeEvent
      | MultiSelectChangeEvent
  ) => {
    setCurrentConfig(prevState => ({ ...prevState, [e.target.id]: e.target.value }));
  };

  return (
    <TabView>
      <TabPanel header={T("word.general")}>
        <ProductTemplateGeneralConfig
          currentConfig={currentConfig}
          setCurrentConfig={setCurrentConfig}
          handleConfigChange={handleConfigChange}
        />
      </TabPanel>
      <TabPanel header={T("header.table-config")}>
        <ProductTemplateTableConfig
          currentConfig={currentConfig}
          handleConfigChange={handleConfigChange}
        />
      </TabPanel>
      <TabPanel header={T("word.filters")}>
        <ProductTemplateFilterConfig
          currentConfig={currentConfig}
          handleConfigChange={handleConfigChange}
        />
      </TabPanel>
      <TabPanel header={T("header.overridden-column-values")}>
        <ProductTemplateOverriddenColumnValues
          currentConfig={currentConfig}
          setCurrentConfig={setCurrentConfig}
        />
      </TabPanel>
      <TabPanel header={T("load-conf.load-config")}>
        <ProductTemplateLoadConfig
          currentConfig={currentConfig}
          setCurrentConfig={setCurrentConfig}
        />
      </TabPanel>
    </TabView>
  );
};

export default ProductTemplateTableEditor as FunctionComponent;
